import { Navigate } from "react-router";

const PrivateRoute = ({ children }) => {
    const user = localStorage.getItem('token');
    const labUserCheck = user ? JSON.parse(atob(user.split('.')[1])) : null;

    if (!labUserCheck || labUserCheck?.ValidOTP !== 'True' || labUserCheck?.OnboardRequest === 'True') {
        return <Navigate to='/' replace />;
    }

    // External users are not subject to the Permission requirement
    const isExternal = labUserCheck?.UserType === 'External';
    const hasPermission = isExternal || (labUserCheck?.Permission &&
        (Array.isArray(labUserCheck.Permission) ? labUserCheck.Permission.length > 0 : true));

    if (!hasPermission) {
        return <Navigate to='/error' replace />;
    }

    return children;
};

export default PrivateRoute;